<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">Faturamento > Contas de Recebimento</span>
    </p-header>
    <app-receiving-accounts-dialog></app-receiving-accounts-dialog>
</p-fieldset>